import * as React from "react";

import * as styles from "./Bold.styles";

interface BoldProps {
    children: React.ReactNode;
}

export function Bold(props: BoldProps): JSX.Element {
    return <span css={styles.bold}>{props.children}</span>;
}
